<template>
  <v-sheet
    class="d-flex align-center justify-center"
    width="100%"
    height="100vh"
  >
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-sheet
        v-if="!loading && slides.length"
        class="position-relative slides"
        width="100%"
      >
        <hooper-container
          class="slides-container"
          style="height: 100vh"
          ref="carousel"
          :wheelControl="false"
          autoPlay
          :playSpeed="5000"
          hoverPause
          :mouseDrag="slides.length > 1"
          :touchDrag="slides.length > 1"
          :infiniteScroll="slides.length > 1"
          @slide="updateCarousel"
        >
          <template v-for="(item, i) in slides">
            <hooper-slide v-if="business && item.img" :key="i">
              <SlideShowPropertyCard v-bind="item" />
            </hooper-slide>

            <hooper-slide v-else-if="!business && item.img_desktop" :key="i">
              <SlideShowCard v-bind="item" />
            </hooper-slide>
          </template>
        </hooper-container>

        <div
          v-if="slides.length > 1"
          class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav"
        >
          <a
            class="
              d-flex
              align-center
              justify-center
              pr-1
              cursor-pointer
              slides-nav-item
            "
            @click.prevent="slidePrev"
          >
            <v-icon color="white" :size="xsOnly ? 20 : 30">
              fa-angle-left
            </v-icon>
          </a>
          <a
            class="
              d-flex
              align-center
              justify-center
              pl-1
              cursor-pointer
              slides-nav-item
            "
            @click.prevent="slideNext"
          >
            <v-icon color="white" :size="xsOnly ? 20 : 30">
              fa-angle-right
            </v-icon>
          </a>
        </div>

        <v-container class="py-0 relative">
          <div v-if="!business" class="highlight-categories">
            <v-btn
              to="/?negociacao=alugar"
              class="
                py-3 py-md-5 py-lg-0
                highlight-category highlight-category-center
              "
              :color="colors[0]"
              depressed
              tile
            >
              <div class="d-flex flex-sm-column justify-center align-center">
                <img
                  class="d-block filter-white mb-1 mr-2 mr-sm-0"
                  src="../../assets/img/rent.png"
                  height="56px"
                />

                <div
                  class="
                    text-h6
                    white--text
                    font-weight-bold
                    highlight-category-title
                  "
                >
                  ALUGAR
                </div>
              </div>
            </v-btn>

            <v-btn
              to="/?negociacao=comprar"
              class="
                d-flex
                align-center
                justify-center
                py-3 py-md-5 py-lg-0
                highlight-category highlight-category-right
              "
              :color="colors[1]"
              depressed
              tile
            >
              <div class="d-flex flex-sm-column justify-center align-center">
                <img
                  class="d-block filter-white mb-1 mr-2 mr-sm-0"
                  src="../../assets/img/buy.png"
                  height="56px"
                />

                <div
                  class="
                    text-h6
                    white--text
                    font-weight-bold
                    highlight-category-title
                  "
                >
                  COMPRAR
                </div>
              </div>
            </v-btn>
          </div>

          <div
            v-else-if="featuredCategories"
            :class="[
              'highlight-categories highlight-categories-' +
                featuredCategories.length,
            ]"
          >
            <template
              v-for="({ title, to }, keyCategories) in featuredCategories"
            >
              <v-btn
                :key="keyCategories"
                :to="to"
                class="
                  py-3 py-md-5 py-lg-0
                  highlight-category highlight-category-center
                "
                :color="colors[keyCategories]"
                depressed
                tile
              >
                <div class="d-flex justify-center align-center">
                  <div
                    class="
                      text-h6
                      white--text
                      font-weight-bold
                      highlight-category-title
                    "
                  >
                    {{ title }}
                  </div>
                </div>
              </v-btn>
            </template>
          </div>
        </v-container>
      </v-sheet>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import SlideShowCard from "../cards/SlideShowCard.vue";
import SlideShowPropertyCard from "../cards/SlideShowPropertyCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "slides",
};

export default {
  data: () => ({
    loading: true,
    loadingCategories: false,
    slides: [],
    categories: [],
    carouselData: 0,
    colors: [
      "rgba(158, 158, 158, 0.9)",
      "rgba(117, 117, 117, 0.9)",
      "rgba(97, 97, 97, 0.9)",
      "rgba(66, 66, 66, 0.9)",
    ],
  }),
  created() {
    this.getList();

    this.$rest("featuredCategories").get();
  },
  computed: {
    featuredCategoriesId() {
      return this.$rest("featuredCategories").list;
    },
    featuredCategories() {
      return this.categories
        .filter(({ id }) => this.featuredCategoriesId.includes(String(id)))
        .filter((item, key) => key < 4);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    filters() {
      return this.$route.query;
    },
    business() {
      return ["comprar", "alugar"].includes(this.filters.negociacao)
        ? this.filters.negociacao === "alugar"
          ? 1
          : 2
        : undefined;
    },
  },
  methods: {
    getCategories() {
      this.loading = true;

      const params = {
        business: this.business,
      };

      this.$rest("propertiesCategories")
        .get({ params })
        .then((data) => {
          this.categories = data.map(({ id, title }) => ({
            id,
            title,
            to: (this.business === 1 ? "/alugar" : "/comprar") + `?t=${id}`,
          }));
        })
        .then(() => (this.loading = false));
    },
    getList() {
      this.loading = true;

      if (!this.business) {
        this.$rest(_config.mod)
          .get()
          .then((data) => {
            this.slides = data;
          })
          .then(() => (this.loading = false));
      } else {
        this.getCategories();

        const params = {
          featured: 1,
        };

        params.business = this.business;

        this.$rest("properties")
          .get({ params })
          .then((data) => {
            this.slides = data.map(
              ({
                id,
                title,
                img,
                business,
                district,
                city,
                state,
                area,
                total_area,
                garage,
                bedrooms,
                pool,
              }) => ({
                img,
                title,
                business,
                district: district
                  ? district +
                    (city ? ` - ${city}` + (state ? `/${state}` : "") : "")
                  : "",
                details: [
                  {
                    icon: "fas fa-bed",
                    text: Number(bedrooms) > 0 ? Number(bedrooms) : 0,
                  },
                  {
                    icon: "fas fa-car",
                    text: Number(garage) > 0 ? Number(garage) : 0,
                  },
                  {
                    icon: "fas fa-swimmer",
                    text: Number(pool) > 0 ? Number(pool) : 0,
                  },
                  {
                    icon: "fas fa-home",
                    text: parseFloat(area) > 0 ? `${area}m²` : 0,
                  },
                  {
                    icon: "fas fa-expand-arrows-alt",
                    text: parseFloat(total_area) > 0 ? `${total_area}m²` : 0,
                  },
                ],
                to:
                  (business === "Venda" ? "/comprar" : "/alugar") +
                  `/${formatToURL(title)}-${id}`,
              })
            );
          })
          .then(() => (this.loading = false));
      }
    },
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    $route() {
      this.getList();
    },
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  components: {
    LoadingWidget,
    SlideShowCard,
    SlideShowPropertyCard,
  },
};
</script>

<style lang="scss">
.v-dialog {
  overflow: visible !important;
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
.slides-container::v-deep {
  ol,
  ul {
    padding-left: 0 !important;
  }
}

.slides {
  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }

    &-item {
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      height: 50px;
      transition: all 0.1s linear;
      width: 50px;

      &:hover {
        background-color: var(--v-primary-base);
      }

      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
    }
  }
}

.highlight-categories {
  img {
    aspect-ratio: 1 / 1;
    object-fit: contain;
  }

  @media screen and (max-width: 1264px) {
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    left: 0;
    position: fixed;
    width: 100%;
  }

  .highlight-category {
    @media screen and (max-width: 1264px) {
      flex: 0 1 50%;
      height: auto !important;
    }

    img {
      @media screen and (max-width: 1264px) {
        filter: brightness(0) invert(1);
      }

      @media screen and (max-width: 600px) {
        height: 20px;
      }
    }

    .highlight-category-title {
      @media screen and (max-width: 1264px) {
        color: #ffffff !important;
      }
    }
  }

  @media screen and (min-width: 1264.001px) {
    bottom: 62px;
    display: flex;
    position: absolute;
    right: 0;

    .highlight-category {
      border-radius: 25rem;
      height: 270px;
      width: 270px;

      &:nth-child(2) {
        margin-left: -40px;
        z-index: 2;
      }

      &:nth-child(3) {
        margin-left: -500px;
        margin-top: 230px;
        z-index: 3;
      }

      &:nth-child(4) {
        margin-left: -40px;
        margin-top: 230px;
        z-index: 4;
      }
    }
  }
}
</style>
